module.exports = app_ssal_savedSearchManagement;